import React from "react";
import TableDataGrid from "./TableDataGrid";
import Box from "@mui/material/Box";
import Request from "../Utils/Request/Request";
import { useState, useContext, useEffect } from "react";
import { AppStorage } from "../Utils/Context/AppContext";
import { getErrorMessage, showToast } from "../Utils/index";
import PdfIcon from "@mui/icons-material/PictureAsPdf";
import SendIcon from "@mui/icons-material/Send";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRangePicker } from "react-date-range";
import moment from "moment";
import { CircularProgress, TextField, Typography } from "@mui/material";
import Loader from "./Loader";
import DialogProducts from "./DialogProducts";
import { useTranslation } from "react-i18next";
import { getDocumentId } from "../Utils/documentNumber";

function AllSalesReturn() {
  const [openInvoiceProducts, setOpenInvoiceProducts] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const { t, i18n } = useTranslation();
  const handleOpenInvoiceProducts = (value) => {
    setOpenInvoiceProducts(true);
    setSelectedItem(value);
  };

  const handleCloseInvoiceProducts = () => {
    setOpenInvoiceProducts(false);
  };

  let date = new Date();
  date.setMonth(date.getMonth() - 1);
  const [showDatePicker, setShowDatePicker] = useState(false);

  const [invoices, setInvoices] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submittingIds, setSubmittingIds] = useState(new Set());
  const [startDate, setStartDate] = useState(date);
  const [endDate, setEndDate] = useState(new Date());
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 7,
  });
  const [searchPhrase, setSearchPhrase] = useState("");


  const AppContext = useContext(AppStorage);

  useEffect(() => {
    const statusColumns = Number(AppContext?.userInfo?.zatca_phase) === 2 ? [zatcaColumn] : [];
    if(AppContext?.userInfo.role &&  AppContext?.userInfo.role != "user") {
      setTableColumns(columns.concat(statusColumns, userColumn, actionColumn));
    } else {
      setTableColumns(columns.concat(statusColumns, actionColumn));
    }
  }, [AppContext?.userInfo, i18n.language, submittingIds]);

  useEffect(() => {
    if (AppContext?.userAuthToken || AppContext?.userAuthToken !== "") {
      getData({ pagination, searchPhrase });
    }
  }, [AppContext?.userAuthToken, pagination?.current, AppContext?.userInfo, i18n.language]);

  useEffect(() => {
    if (AppContext?.userInfo?.role === "admin") {
      i18n.changeLanguage("en");
    }
  },[AppContext?.userAuthToken, pagination?.current, AppContext?.userInfo, i18n.language])
  
  function getData(params) {
    setLoading(true);
    let paramsData = {};

    paramsData = {
      ...paramsData,
      startDate: params?.dateStart || moment.utc(moment(startDate).format().substring(0, 10)).format(),
      endDate: params?.dateEnd || moment.utc(moment(endDate).format().substring(0, 10)).format(),
      searchPhrase: params.searchPhrase,
      salesReturn: true
    };

    Request.get(`/getInvoice/${params.pagination?.current}`, paramsData)
      .then((result) => {
        setLoading(false);
        setInvoices(result.data["data"]);
        setPagination({
          ...params.pagination,
          total: result.data["totalCount"],
        });
        setSearchPhrase(params.searchPhrase);
      })
      .catch((err) => {
        setLoading(false);
        console.log("Error: ", err);
        if (err.response.status == 401) {
          showToast("error", "Unauthorized user.");
        } else {
          showToast("error", "Something went wrong.");
        }
      });
  }

  const handleSelect = (date) => {
    const dateStart =  moment.utc(moment(date.selection.startDate).format().substring(0, 10)).format();
    const dateEnd = moment.utc(moment(date.selection.endDate).format().substring(0, 10)).format();
   
    setStartDate(date.selection.startDate);
    setEndDate(date.selection.endDate);
    
    getData({ pagination, dateStart, dateEnd });
  };
  const handleChange = (event, value) => {
    let dupPagination = { ...pagination };
    dupPagination.current = value;
    setPagination(dupPagination);
  
  };
  function searchChange(value) {
    setSearchPhrase(value)
    setPagination({ ...pagination, current: 1 });
    getData({ pagination: { ...pagination, current: 1 }, searchPhrase: value });
  }

  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: "selection",
  };

  const columns = [
    { field: "rowNumber", headerName: `${t('SR-NO.')}`, width: 70 },
    {
      field: "sr_document_number",
      headerName: `${t("Document Number")}`,
      width: 150,
      renderCell: (params) => getDocumentId(params.row),
    },
    { field: "original_invoice_number", headerName: `${t("Original Invoice Number")}`, width: 170 },
    { field: "companyName", headerName: `${t("Client")}`, width: 200 },
    { field: "vatNumber", headerName: `${t("Vat Number")}`, width: 100 },
    { field: "total", headerName: `${t("Total")}`, width: 120 },
    {
      field: "invoiceproducts",
      headerName: `${t("No. of Products")}`,
      renderCell: (text) => {
        return (
          <div>
            <Button
              variant="outlined"
              onClick={() => handleOpenInvoiceProducts(text)}
            >
              {text?.value?.length}
            </Button>
          </div>
        );
      },
      width: 150,
    },
    {
      field: "invoiceDate",
      headerName: `${t("Invoice Date")}`,
      renderCell: (text) => (
        <span>{moment.utc(text?.value).format("YYYY-MM-DD")}</span>
      ),
      width: 130,
    },
    {
      field: "original_invoice_date",
      headerName: `${t("Original Invoice Date")}`,
      renderCell: (text) => (
        <span>{text?.value ? moment.utc(text.value).format("YYYY-MM-DD") : ""}</span>
      ),
      width: 160,
    },
  ];

  const submitToZatca = (invoiceId) => {
    setSubmittingIds((current) => new Set(current).add(invoiceId));
    Request.post(`/invoice/${invoiceId}/zatca-send`, {})
      .then((result) => {
        showToast("success", t("Sales return submitted to ZATCA successfully."));
        const zatcaData = result?.data?.data;
        if (zatcaData) {
          setInvoices((current) =>
            current.map((invoice) =>
              invoice.id === invoiceId ? { ...invoice, ...zatcaData } : invoice
            )
          );
        }
      })
      .catch((err) => {
        showToast("error", getErrorMessage(err, t("ZATCA submission failed.")));
      })
      .finally(() => {
        setSubmittingIds((current) => {
          const next = new Set(current);
          next.delete(invoiceId);
          return next;
        });
      });
  };

  const zatcaColumn = {
    field: "zatca_status",
    headerName: t("ZATCA Status"),
    width: 150,
    sortable: false,
    renderCell: (params) => {
      const status = String(params.value || "PENDING").toUpperCase();
      const badges = {
        CLEARED: { bg: "#e8f5e9", color: "#2e7d32", label: "CLEARED" },
        REPORTED: { bg: "#e3f2fd", color: "#1565c0", label: "REPORTED" },
        FAILED: { bg: "#ffebee", color: "#c62828", label: "FAILED" },
        PENDING: { bg: "#fff8e1", color: "#f57f17", label: "PENDING" },
        SKIPPED: { bg: "#f3f3f3", color: "#757575", label: "SKIPPED" },
        NONE: { bg: "#f3f3f3", color: "#9e9e9e", label: "LEGACY" },
      };
      const badge = badges[status] || { bg: "#f3f3f3", color: "#555", label: status };
      return (
        <span style={{
          display: "inline-block",
          padding: "2px 10px",
          borderRadius: "12px",
          fontSize: "11px",
          fontWeight: 700,
          letterSpacing: "0.5px",
          background: badge.bg,
          color: badge.color,
          border: `1px solid ${badge.color}44`,
        }}>
          {badge.label}
        </span>
      );
    },
  };

  let actionColumn = [
    {
      headerName: `${t("Actions")}`,
      renderCell: (record) => {
        const status = String(record.row?.zatca_status || "PENDING").toUpperCase();
        const isPhase2 = Number(AppContext?.userInfo?.zatca_phase) === 2;
        const originalStatus = String(record.row?.original_zatca_status || "").toUpperCase();
        const hasOriginalStatus = Boolean(originalStatus);
        const isOriginalSubmitted = ["REPORTED", "CLEARED"].includes(originalStatus);
        const canTrySubmit = isPhase2 && ["PENDING", "FAILED"].includes(status);
        const canSubmit = canTrySubmit && (!hasOriginalStatus || isOriginalSubmitted);
        const isSubmitting = submittingIds.has(record.row.id);
        const tooltipTitle = canSubmit
          ? t("Send to ZATCA")
          : hasOriginalStatus && !isOriginalSubmitted
            ? t("Submit the original invoice to ZATCA before submitting this sales return.")
            : t("Send to ZATCA");
        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: "8px", height: "100%" }}>
            {(AppContext?.userInfo.role === "admin" || AppContext?.userInfo.role === "user") &&(
                <PdfIcon
                  sx={{ cursor: "pointer", color: "#FF0000", display: "block" }}
                  onClick={() => printInvoice(record.row)}
                  />
            )}
            {canTrySubmit && (
              <Tooltip title={tooltipTitle}>
                <span>
                  <IconButton
                    size="small"
                    disabled={!canSubmit || isSubmitting}
                    onClick={(event) => {
                      event.stopPropagation();
                      if (!canSubmit) return;
                      submitToZatca(record.row.id);
                    }}
                    sx={{ color: "#365b6d" }}
                  >
                    {isSubmitting ? <CircularProgress size={18} /> : <SendIcon fontSize="small" />}
                  </IconButton>
                </span>
              </Tooltip>
            )}
             
          </Box>
        );
      },
    },
  ];

  let userColumn = [
    { 
      field: "user", headerName: "User Name",
      renderCell: (text) => {
        return (
          <div> {text.value.fullName}</div>
        );
      },
      width: 70
    },
  ]

  function printInvoice(invoice) {
    window.open(`/invoice/${invoice.id}`, "_blank")?.focus();
  }
  return (
    <Box className="portal-list-page">
   
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          width: "100%",
          marginBottom: "0px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexWrap: { xs: "wrap", sm: "nowrap" },
            alignItems: "center",
            gap: { xs: 1.5, sm: 0 },
            width: { xs: "100%", md: "auto" },
          }}
        >
        <Box
          onClick={() => setShowDatePicker(true)}
          onMouseEnter={() => setShowDatePicker(true)}
          onMouseLeave={() => setShowDatePicker(false)}
          sx={{
            width: { xs: "100%", sm: "332px" },
            flex: { xs: "1 1 100%", sm: "0 0 auto" },
            minWidth: 0,
            position: "relative",
            "& .rdrDateRangePickerWrapper": {
              width: "100%",
              "& .rdrCalendarWrapper ": {
                width: "100%",
              },
            },
            "& .rdrMonthAndYearWrapper": {
              position: "absolute",
              top: 70,
              background: "white",
              width: "100%",
              display: showDatePicker ? "" : "none",
              zIndex: 999,
              boxShadow: "0px 3px 8px rgb(100,100,100)",
            },
            "& .rdrMonths ": {
              position: "absolute",
              top: 130,
              background: "white",
              display: showDatePicker ? "" : "none",
              zIndex: 999,
              boxShadow: "0px 3px 8px rgb(100,100,100)",
            },
          }}
        >
          <DateRangePicker
            ranges={[selectionRange]}
            onChange={handleSelect}
            moveRangeOnFirstSelection={false}
            retainEndDateOnFirstSelection={true}
          />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", flexBasis: { xs: "100%", sm: "auto" }, width: { xs: "100%", sm: "auto" } }}>
          <TextField
            type="text"
            autoComplete="off"
            placeholder= {t("Search Company/Invoice NO.")}
            onChange={(event) => searchChange(event.target.value)}
            sx={{
              width: { xs: "100%", sm: "250px" },
              marginRight: { xs: 0, sm: "20px" },
              "& .MuiOutlinedInput-input": { height: "1em" },
              "& fieldset": {
                borderColor: "#365b6d !important",
              },
            }}
          />
        </Box>
        </Box>
      </Box>

      <div className="portal-list-body">
        <Typography variant="h6" sx={{ color: "#365b6d", textAlign: "center" }}>
          {t("All Sales Return")}
        </Typography>
        {loading ? (
          <Loader />
        ) : (
          <>
            <TableDataGrid
              // rows={invoices}
              rows={invoices.map((invoice, index) => ({
                ...invoice,
                rowNumber: (pagination.current - 1) * 7 + (index + 1),
              }))}
              columns={tableColumns}
              disableColumnMenu
              hideFooter
              checkboxSelection={false}
              disableSelectionOnClick
            />
            <Stack spacing={2} marginTop="5px">
              <Pagination
                count={Math.ceil(pagination?.total / 7)}
                page={pagination?.current}
                onChange={handleChange}
              />
            </Stack>
          </>
        )}
      </div>
      <DialogProducts
        handleCloseInvoiceProducts={handleCloseInvoiceProducts}
        openInvoiceProducts={openInvoiceProducts}
        text={selectedItem}
      />
    </Box>
  );
}

export default AllSalesReturn;
